var map = {
	"./afirme-full.png": "2b9a",
	"./afirme-white-full.png": "3050",
	"./ana-full.png": "af76",
	"./ana-white-full.png": "6214",
	"./axa-full.png": "1f3a",
	"./axa-white-full.png": "860a",
	"./chubb-full.png": "40e7",
	"./chubb-white-full.png": "d649",
	"./chubbhogar-1-full.png": "9ec1",
	"./chubbhogar-2-full.png": "4245",
	"./chubbhogar-3-full.png": "2b91",
	"./chubbhogar-4-full.png": "3226",
	"./chubbhogar-full.png": "5e34",
	"./gnp-full.png": "eb35",
	"./gnp-white-full.png": "21b7",
	"./hdi-full.png": "e276",
	"./hdi-white-full.png": "2159",
	"./mapfre-full.png": "4f0b",
	"./mapfre-white-full.png": "2131",
	"./primeroSeguros-full.png": "89ca",
	"./primeroSeguros-white-full.png": "fe31",
	"./qualitas-full.png": "7f53",
	"./qualitas-white-full.png": "0f0b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "231a";